import { CommonModule } from '@angular/common';
import { Component,  EventEmitter,  Input, Output } from '@angular/core';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';

@Component({
    selector: 'percent-box',
    template: `

<joi-input
  [(model)]="percent"
  (joiChange)="onChange.emit(percent)"
  [placeholder]="'0'"
  [allowableCharacters]="'0123456789.'"
></joi-input>
<div class="percent">%</div>

`,
    styles: [`
  :host { display: flex; flex-direction: row; align-items: center; }
  joi-input { width: fit-content; }
`],
    standalone: true,
    imports: [JoiInputComponent, CommonModule],
})
export class PercentBoxComponent {
  @Input() percent: string
  @Output() onChange: EventEmitter<string> = new EventEmitter()

}

